import * as profitConstant from './constants'
export const profitReportNvkdRequest = (formData) => {
  return {
    type: profitConstant.PROFIT_REPORT_NVKD_REQUESTING,
    formData
  }
}

export const profitReportNvkdSuccess = (data) => {
  return {
    type: profitConstant.PROFIT_REPORT_NVKD_SUCCESS,
    data
  }
}

export const profitReportNvkdError = (error) => {
  return {
    type: profitConstant.PROFIT_REPORT_NVKD_ERROR,
    error
  }
}
export const profitReportKhRequest = (formData) => {
  return {
    type: profitConstant.PROFIT_REPORT_KH_REQUESTING,
    formData
  }
}

export const profitReportKhSuccess = (data) => {
  return {
    type: profitConstant.PROFIT_REPORT_KH_SUCCESS,
    data
  }
}

export const profitReportKhError = (error) => {
  return {
    type: profitConstant.PROFIT_REPORT_KH_ERROR,
    error
  }
}
export const profitReportKhoXuatRequest = (formData) => {
  return {
    type: profitConstant.PROFIT_REPORT_KHOXUAT_REQUESTING,
    payload: formData
  }
}

export const profitReportKhoXuatSuccess = (data) => {
  return {
    type: profitConstant.PROFIT_REPORT_KHOXUAT_SUCCESS,
    data
  }
}

export const profitReportKhoXuatError = (error) => {
  return {
    type: profitConstant.PROFIT_REPORT_KHOXUAT_ERROR,
    error
  }
}
export const profitReportListRequest = (formData) => {
  return {
    type: profitConstant.PROFIT_REPORT_LIST_REQUESTING,
    formData
  }
}

export const profitReportListSuccess = (data) => {
  return {
    type: profitConstant.PROFIT_REPORT_LIST_SUCCESS,
    data
  }
}

export const profitReportListError = (error) => {
  return {
    type: profitConstant.PROFIT_REPORT_LIST_ERROR,
    error
  }
}

export const reportExportXlsRequest = (formData, callback) => {
  return {
    type: profitConstant.PROFIT_REPORT_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const reportExportXlsSuccess = (data) => {
  return {
    type: profitConstant.PROFIT_REPORT_EXPORT_XLS_SUCCESS,
    data
  }
}

export const reportExportXlsError = (error) => {
  return {
    type: profitConstant.PROFIT_REPORT_EXPORT_XLS_ERROR,
    error
  }
}

export const profitReportNhomKhRequest = (formData, callback) => {
  return {
    type: profitConstant.PROFIT_REPORT_NHOMKH_REQUESTING,
    payload: formData,
    callback
  }
}

export const profitReportNhomKhSuccess = (data) => {
  return {
    type: profitConstant.PROFIT_REPORT_NHOMKH_SUCCESS,
    data
  }
}

export const profitReportNhomKhError = (error) => {
  return {
    type: profitConstant.PROFIT_REPORT_NHOMKH_ERROR,
    error
  }
}

export const profitReportKhByNhomRequest = (formData, callback) => {
  return {
    type: profitConstant.PROFIT_REPORT_KH_BY_NHOM_REQUESTING,
    payload: formData,
    callback
  }
}

export const profitReportKhByNhomSuccess = (data) => {
  return {
    type: profitConstant.PROFIT_REPORT_KH_BY_NHOM_SUCCESS,
    data
  }
}

export const profitReportKhByNhomError = (error) => {
  return {
    type: profitConstant.PROFIT_REPORT_KH_BY_NHOM_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Reports/ProfitReport/actions.js